// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1__2a","cls2":"ProfilePdfPackCard-cls2_wqV ProfilePdfPackCard-cls1__2a"};